import React, { memo } from 'react'
import { SpotBiddingRulesHeader } from 'apps/spot-quote-control-panel/components/SpotBiddingRulesHeader'
import { Table, TableBody } from 'transfix-ui'
import { ISpotBiddingRule } from '../types/spotBiddingConfig'
import { SpotBiddingRulesTableRow } from './SpotBiddingRulesTableRow'

interface ISpotBiddingRulesTableProps {
  spotBiddingRules: ISpotBiddingRule[]
  globalRules?: ISpotBiddingRule[]
  dataTest?: string
  readOnly?: boolean
}

export const SpotBiddingRulesTable = memo<ISpotBiddingRulesTableProps>(
  ({
    spotBiddingRules,
    globalRules = [],
    readOnly = false,
    dataTest = 'spot-bidding-rules-table',
  }) => {
    if (spotBiddingRules.length === 0) {
      return (
        <div className='tc mv2'>
          <h3>No rules for this shipper</h3>
        </div>
      )
    }
    return (
      <Table>
        <SpotBiddingRulesHeader readOnly={readOnly} />
        <TableBody dataTest={dataTest}>
          {globalRules.map(rule => (
            <SpotBiddingRulesTableRow
              key={rule.id}
              readOnly={readOnly}
              spotBiddingRule={rule}
              isGlobal
            />
          ))}
          {spotBiddingRules.map(rule => (
            <SpotBiddingRulesTableRow key={rule.id} readOnly={readOnly} spotBiddingRule={rule} />
          ))}
        </TableBody>
      </Table>
    )
  }
)
